import { NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import {
  getApiWithAuthorization,
  getApiWithoutAuthorization,
  postApiWithAuthorization,
} from "../ApiMethod/ApiMethod";

const timeSlotBaseURI = `${NewUpdatedBaseUrl}/TimeSlot`;


export const GetTimeSlotLookupList = async () => {
  const url = `${timeSlotBaseURI}/GetTimeSlotLookupList`;
  const res = await getApiWithAuthorization(url);
  return res;
};